import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { CookieService } from 'src/app/customServices/cookie.service';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';

@Component({
  selector: 'app-can-navigate-checkout',
  templateUrl: './can-navigate-checkout.component.html',
  styleUrls: ['./can-navigate-checkout.component.scss'],
  standalone: false
})
export class CanNavigateCheckoutComponent implements OnDestroy {

  cartDetails: any;
  activeCart$: any;

  subscription = new Subscription();
  cartId: string;
  constructor(private CheckOutService: KbCheckOutService,
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private translationService: TranslationService,
    private activeCart: ActiveCartFacade,
    private cookieService: CookieService,
    private cartTrackingService: CartTrackingService,
  ) {
    this.subscription.add(
      this.activeCart.getActive().subscribe((data) => {
        this.cartDetails = data.entries;
        this.cartId = data.code;

      }));
  }
  redirectToCheckoutPage() {
    this.CheckOutService.canNavigateToCheckOut(true, this.CheckOutService.cartCode).subscribe((x) => {
      if (x) {
        if ((x?.['status'] == 'SUCCESS')) {
          this.activeCart.reloadActiveCart();
          this.cartTrackingService.trackCheckout(this.cartDetails, this.cartId);
          this.router.navigate(['multiStepCheckoutSummary']);
        }
        else if ((x?.['status'] == 'ERROR')) {
          this.cookieService.setItemSessionStorage('userInwhichStep', 0);
          this.subscription.add(this.translationService.translate(x?.['message'])
            .subscribe((key) => {
              if (key.includes('{0}')) {
                key = key.replace('{0}', x?.['errorValue1']);
              }
              if (key.includes('{1}')) {
                key = key.replace('{1}', x?.['errorValue2']);
              }
              this.hitGlobalMessage(key);
            }));
        }
      }
    })
  }

  hitGlobalMessage(keyValue) {
    this.globalMessageService.add(keyValue,
      GlobalMessageType.MSG_TYPE_ERROR
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
